import { AppDispatch, RootState } from '../../../store'
import { AnyAction } from 'redux'
import { updateAppAlert } from '../../../common/modules/appAlert/actions'
import { getErrorMessages } from '../../../common/utils/error'
import { RequestFailureMessage } from '../../../common/utils/messagesContants'
import { AxiosError, AxiosResponse } from 'axios'
import { errorLogger } from '../../../common/utils/errorLogger'
import { generateEmbedUrl, getOverviewData } from '../../api/markeplace'
import { camelize } from 'casing'
import { OverviewState, RevenueData } from './reducer'
import { getMonthAbbreviation } from '../../../common/utils/getGraphDateLabel'
import { getWorkatoIframeUrlApi } from '../../../common/api'

import { LoadingTypes, startLoading, stopLoading } from '@labrav/common'
export enum OverviewActionTypes {
  SET_OVERVIEW = 'SET_OVERVIEW',
}

export const getFlyoutOverview =
  ({ partnerId }: { partnerId: string }) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    await dispatch(startLoading(LoadingTypes.FLYOUT_OVERVIEW))
    try {
      const response = await getOverviewData({ partnerId })
      const overviewData = camelize(response?.data ?? {})
      if (
        !overviewData.overview?.revenue ||
        Object.keys(overviewData.overview.revenue).length === 0
      ) {
        await dispatch(setOverviewData(overviewData))
      } else {
        const transformedOverviewData = {
          ...overviewData,
          overview: {
            ...overviewData.overview,
            revenue: {
              ...overviewData.overview.revenue,
              revenueData: overviewData.overview.revenue.revenueData.map(
                (item: RevenueData) => ({
                  ...item,
                  data: item.data.map(({ date, value }) => ({
                    x: getMonthAbbreviation(date),
                    y: value,
                  })),
                })
              ),
            },
          },
        }
        await dispatch(setOverviewData(transformedOverviewData))
      }
    } catch (error: any) {
      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse<ErrorResponse>
      if (errorResponse?.status !== 403) {
        dispatch(
          updateAppAlert({
            message: getErrorMessages([RequestFailureMessage])(errorResponse),
            messageType: 'ERROR',
            autoClose: true,
          })
        )
      }

      const globalState = getState()
      errorLogger({ globalState })(
        error as Error,
        errorResponse?.data?.track_id
      )
    } finally {
      await dispatch(stopLoading(LoadingTypes.FLYOUT_OVERVIEW))
    }
  }

export const generateEmbedUrlIframe =
  ({ partnerId, data }: { partnerId: string; data: Record<string, unknown> }) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    await dispatch(startLoading(LoadingTypes.GENERATE_EMBED_LOADING))

    try {
      const response = await generateEmbedUrl(data, partnerId)
      const { embed_url, signature } = response.data
      return { embed_url, signature }
    } catch (error: any) {
      dispatch(
        updateAppAlert({
          message: getErrorMessages(['RequestFailureMessage'])(
            error.response as AxiosResponse<ErrorResponse>
          ),
          messageType: 'ERROR',
          autoClose: true,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(error as Error)
    } finally {
      await dispatch(stopLoading(LoadingTypes.GENERATE_EMBED_LOADING))
    }
  }
export const getWorkatoIframeUrl =
  ({ workatoCustomerId, path }: { workatoCustomerId: string; path: string }) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    await dispatch(startLoading(LoadingTypes.WORKATO_LOADING))

    try {
      const response = await getWorkatoIframeUrlApi({ workatoCustomerId, path })
      const { link } = response.data
      return { link }
    } catch (error: any) {
      dispatch(
        updateAppAlert({
          message: getErrorMessages(['RequestFailureMessage'])(
            error.response as AxiosResponse<ErrorResponse>
          ),
          messageType: 'ERROR',
          autoClose: true,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(error as Error)
    } finally {
      await dispatch(stopLoading(LoadingTypes.WORKATO_LOADING))
    }
  }

export const setOverviewData = (overviewData: OverviewState) => ({
  type: OverviewActionTypes.SET_OVERVIEW,
  payload: overviewData,
})
